/**
 * General Application Constants
 * Stores information that must be otherwise returned from configuration
 */
export const APPConstants = Object.freeze({
    APP_BASE_URI: '/',
    COUNTRY_ID: 1,
    CURRENCY_ID: 1,
    MATERIAL_FLOOR_MEASUREMENT_UNIT_ID: 2,
    MATERIAL_MAX_QUANTITY: 5,
    MATERIAL_SELECTION_QUANTITY_STEP: 5,
    UPLOAD_MAX_FILE_SIZE_MB: 5,
    UPLOAD_MAX_FILE_QTY: 5,
    FIX_QUALITY_ENABLE: false,
    PRODUCTION_HOSTNAME: `${process.env.REACT_APP_PRODUCTION_HOSTNAME}`,
    PROJECT: {
        STEPS: {
            UPLOAD_PHOTO: {
                UPLOAD_REZIZE_MAX_WIDTH: 1920,
                UPLOAD_RESIZE_MAX_HEIGHT: 1200,
                UPLOAD_RESIZE_QUALITY: 100,
                UPLOAD_RESIZE_FORMAT: 'jpeg',
                UPLOAD_RESIZE_OUTPUT_TYPE: 'file'
            }
        }
    }
})